import React from 'react';
import { components, type ValueContainerProps } from 'react-select';

import type { DestinationOption } from '@lt/api/dist/methods/references/types';
import DestinationPickerValue from '@lt/components/components/DestinationPickerValue';

export const ValueContainer = ({
  children,
  ...props
}: ValueContainerProps<DestinationOption, false>): JSX.Element => {
  const { getValue, isDisabled } = props;

  const [currentValue] = getValue();

  return (
    <components.ValueContainer {...props}>
      <DestinationPickerValue isDisabled={isDisabled} currentValue={currentValue}>
        {children}
      </DestinationPickerValue>
    </components.ValueContainer>
  );
};
